var Product_Gallery_Akrolab = {
    init: function () {

        console.log("PRODUCT AKROLAB GALERIE INIT");

        $('#slider--product').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            Product_Gallery_Akrolab.move_cell();
        });

    },
    move_cell: function () {
        var _left = $("#product__images--container .carousel-cell.is-nav-selected").position().left;
        console.log("MOVE CELL : " + _left + " // " + $("#slider__nav--product").width());

        if(_left > $("#slider__nav--product").width() / 2){
           $("#slider__nav--product").animate({scrollLeft:$("#slider__nav--product").width()}, 400);
        }else{
            $("#slider__nav--product").animate({scrollLeft:0}, 400);
        }
    }
}

$(window).on("load", function () {

    console.log("____________________" + $(".arkolab-template .product-content").length);

    if ($(".akrolab-template .product-content").length) {

        Product_Gallery_Akrolab.init();
    }
})